<button (click)="onMinimized()" class="button" type="button"><span></span></button>

@if (!isMinimized()) {
  <div class="title">
    <app-logo />
    <div class="title__body">
      <span class="letters">PORTAL</span>
      <span class="brand-version-row">
        <span class="brand-version">v{{ version }}</span>
        <app-icon
          (cdkCopyToClipboardCopied)="onCopied($event)"
          [cdkCopyToClipboard]="'v' + version"
          [color]="'#7c86a5'"
          [iconName]="['Edit', 'copy']"
          [size]="12"
          [title]="'profile_dropdown.COPY_VERSION' | translate"
          class="brand-version-copy-icon"
        ></app-icon>
        @if (versionCopied()) {
          <span class="copy-tooltip">
            {{"profile_dropdown.COPIED" | translate }}
          </span>
        }
      </span>
    </div>
  </div>
}

